import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Error404Component } from '../shared/errors/errors.module';

import { AppGuard } from '../../app.guard';
import { AccountGuard } from './powerplant.guard';
import { PowerplantComponent } from './powerplant.component';

export const routes: Routes = [
  {
    path: 'powerplant',
    data: { title: 'Account' },
    children: [
      { path: '', component: PowerplantComponent, canActivate: [AppGuard] },
      // { path: 'sign-in', component: SignInComponent, canActivate: [AccountGuard] },

      { path: '**', component: Error404Component }, // Error 404
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PowerplantRoutingModule { }